
export enum ColumnSizes {
  XSMALL = 'xsmall',
  SMALL = 'small',
  MEDIUM = 'medium'  
}

export const SizeBasedColumnClasses: {[key: string]: string} = {
  [ColumnSizes.XSMALL] : 'uw-table-column--xsmall',
  [ColumnSizes.SMALL] : 'uw-table-column--small',
  [ColumnSizes.MEDIUM]: 'uw-table-column--medium'  
}

export type ColumnSizeTypes = ColumnSizes;